// import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

import Registration from "./Registration/Registration";
import "./Css/Registration.css";
// import ProfileEdit from './Profile/Profile_Edit';

function RegistrationApp() {
  return (
    <div>
      <Registration />
    </div>
  );
}

export default RegistrationApp;
